import {
  DateRangePresetName,
  getUiDateTimeRangeFromPreset,
  PurchaseDateRangePresetNames,
} from 'src/utils/dateTimeUtils';
import {
  DateTimeRangeWithRelative,
  EventSort,
  MarketplacePaymentLineQuery,
  MarketplacePaymentQuery,
} from 'src/WebApiController';

export const EmptyMarketplacePaymentQuery = {
  marketplace: null,
  paymentDates: null,
  marketplacePaymentState: null,
  isSortDescending: false,
  viewMode: null,
  sortBy: null,
  timezoneOffsetMins: new Date().getTimezoneOffset(),
  currencyCodes: null,
  hasPaymentLineUnmappedToSale: null,
  hasPaymentLineUnmappedToSaleLineItem: null,
  hasPaymentTotalDiscrepancy: null,
  hasProceedsTotalDiscrepancy: null,
  hasChargeTotalDiscrepancy: null,
  hasCreditTotalDiscrepancy: null,
} satisfies MarketplacePaymentQuery;

export const DefaultMarketplacePaymentQuery = {
  ...EmptyMarketplacePaymentQuery,
  paymentDates:
    (getUiDateTimeRangeFromPreset(
      DateRangePresetName.ThisYear,
      PurchaseDateRangePresetNames
    ) as DateTimeRangeWithRelative) ?? null,
  sortBy: EventSort.Date,
  isSortDescending: true,
} satisfies MarketplacePaymentQuery;

export const EmptyMarketplacePaymentLineQuery = {
  hasUnlinkedChargesCredits: null,
  externalSaleIdContains: null,
  viewMode: null,
  timezoneOffsetMins: new Date().getTimezoneOffset(),
} satisfies MarketplacePaymentLineQuery;

export enum PaymentTab {
  MarketplacePayments = 'MarketplacePayments',
  VendorPayments = 'VendorPayments',
  CommissionPayment = 'CommissionPayments',
}
